import React, {PureComponent} from 'react';
import {CanvasOverlay} from 'react-map-gl';

export default class PolylineOverlay extends PureComponent {
	_redraw({width, height, ctx, isDragging, project, unproject}) {
		const {
			points,
			color = '#4a90e2',
			lineWidth = 6,
			renderWhileDragging = false
		} = this.props;

		ctx.clearRect(0, 0, width, height);
		// ctx.globalCompositeOperation = 'lighter';

		ctx.lineCap = "round";
		ctx.lineWidth 	= lineWidth;
		ctx.strokeStyle = color;

		if ((renderWhileDragging || !isDragging) && points) {
			ctx.beginPath();

			points.forEach(point => {
				const pixel = project([point[0], point[1]]);
				ctx.lineTo(pixel[0], pixel[1])
			});


			ctx.stroke();
		}
	}

	render() {
		return <CanvasOverlay redraw={this._redraw.bind(this)}/>
	}
}